import React from 'react';
import Button from '../../Forms/Button';

interface FacturaActionsProps {
    validRequested: boolean;
    validConceptos: boolean;
    invalidArguments: { key: string; text: string };
    usoCfdiError: string;
    // Emitters
    onClear: () => void;
    onPreview: () => void;
}

/** First error found, by priority, or empty when the form is valid */
function errorMessage({ validRequested, validConceptos, invalidArguments, usoCfdiError }: FacturaActionsProps) {
    if (validRequested && !validConceptos) {
        return 'Conceptos con claves de producto o unidad inválidas';
    }
    if (validRequested) {
        return 'Algunos campos faltan de llenarse o contienen errores';
    }
    if (invalidArguments) {
        return invalidArguments.text;
    }
    return usoCfdiError;
}

function FacturaActions(props: FacturaActionsProps) {
    const error = errorMessage(props);
    return (
        <div className="actions">
            {
                error ?
                    <p className="message error">
                        <span className="error">
                            {error}
                        </span>
                    </p>
                    : ''
            }
            <Button secondary={true} handleClick={props.onClear}>
                <span>
                    Limpiar
                </span>
            </Button>
            <Button primary={true} handleClick={props.onPreview}>
                <span>
                    Previsualizar Factura
                </span>
            </Button>
        </div>
    )
}

export default FacturaActions;
